jQuery(document).ready(function($){
	
	if ( typeof $.magnificPopup === 'function' ) {
		//Add Flatsome Lightbox to images in description
		$('.product-description a[href$=".jpeg"], .product-description a[href$=".jpg"], .product-description a[href$=".png"], .product-description a[href$=".mp4"]').magnificPopup({
			//delegate: 'a', // child items selector, by clicking on it popup will open
			type: 'image',
			gallery: {
				enabled: true
			},
			// other options
		});

		//Add Flatsome Lightbox to images in description
		$('.shop_documents a[href$=".jpg"], .shop_documents a[href$=".png"], .shop_documents a[href$=".mp4"]').magnificPopup({
			//delegate: 'a', // child items selector, by clicking on it popup will open
			type: 'iframe',
			gallery: {
				enabled: true
			},
			// other options
		});

		//Add Flatsome Lightbox to images in timeline
		$('#timeline-container a[href$=".jpg"], #timeline-container a[href$=".png"]').magnificPopup({
			//delegate: 'a', // child items selector, by clicking on it popup will open
			type: 'image',
			gallery: {
				enabled: true
			},
			// other options
		});
	}

});
